import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Masked line-by-line reveal for large headings
export const MaskText = ({ lines, className = "", delay = 0, tag = "h2", testId }) => {
  const reduce = useReducedMotion();
  const Tag = motion[tag];
  const container = {
    hide: {},
    show: { transition: { staggerChildren: 0.09, delayChildren: delay } },
  };
  const child = {
    hide: { y: reduce ? 0 : "110%" },
    show: { y: 0, transition: { duration: 1, ease: EASE } },
  };
  return (
    <Tag
      data-testid={testId}
      className={className}
      aria-label={lines.join(" ")}
      variants={container}
      initial="hide"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
    >
      {lines.map((line, i) => (
        <span className="mask-line" key={i} aria-hidden>
          <motion.span
            style={{ display: "block", willChange: "transform" }}
            variants={child}
            dangerouslySetInnerHTML={{ __html: line }}
          />
        </span>
      ))}
    </Tag>
  );
};

// Simple fade + rise on view
export const Reveal = ({ children, className = "", delay = 0, y = 40, testId }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      data-testid={testId}
      className={className}
      initial={reduce ? { opacity: 1 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
};
